import React from "react";
import "../assets/styles/Showcase.scss";
import explainer from "../assets/media/explainer.mp4";
import explainerPoster from "../assets/media/explainer.webp";
import { SOCIAL_PROFILES } from "../data/socialProfiles";

/**
 * Homepage "see it in action": the 75-second walkthrough — follow a match,
 * build an alert, it fires, Ask Guru, backtest. Click to play; nothing loads
 * until then (poster only).
 */
function Showcase() {
  return (
    <section className="showcase-outer" id="see-it-in-action">
      <div className="showcase-header" data-aos="fade-up">
        <span className="section-eyebrow">See it in action</span>
        <h2 className="section-title">From a live match to your lock screen</h2>
        <p className="section-description">
          Follow the match minute by minute, set the rules of your own alert,
          get told the moment it fires, ask Guru why — and check how often it
          would have fired in the past.
        </p>
      </div>

      <div className="showcase-video" data-aos="fade-up" data-aos-delay="100">
        <video
          controls
          preload="none"
          playsInline
          poster={explainerPoster}
          aria-label="Goal Guru walkthrough: following a match, building a smart alert, the alert firing, Ask Guru and a backtest"
        >
          <source src={explainer} type="video/mp4" />
        </video>
      </div>

      <ul className="showcase-points" data-aos="fade-up" data-aos-delay="150">
        <li>
          <strong>Your rules.</strong> Shots, corners, pressure, score and the
          exact minutes.
        </li>
        <li>
          <strong>Told in time.</strong> The alert lands while the match is
          still open.
        </li>
        <li>
          <strong>Proven first.</strong> Backtest any alert against real past
          matches.
        </li>
      </ul>

      <p className="showcase-note">Recorded in the app on a demo matchday.</p>
      <p className="showcase-more">
        More short clips on{" "}
        {SOCIAL_PROFILES.map(({ name, url }, i) => (
          <React.Fragment key={name}>
            {i > 0 && (i === SOCIAL_PROFILES.length - 1 ? " and " : ", ")}
            <a href={url} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          </React.Fragment>
        ))}
        .
      </p>
    </section>
  );
}

export default Showcase;
